import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {SEGMENTS_QUERY_KEY} from "../queryKeys";
import {ReachSegment} from "./types";

type Variables = {};

const getSegments = async (): Promise<ReachSegment[]> => {
  const response = await axiosReachInstance.get<ReachSegment[], AxiosResponse<ReachSegment[]>>("/segments");
  return response.data;
};

export const useGetSegments = (
  variables: Variables = {},
  options?: BaseQueryOptions<ReachSegment[], Variables>
): BaseUseQueryResult<ReachSegment[]> => {
  return useBaseQuery<ReachSegment[], Variables>([SEGMENTS_QUERY_KEY], getSegments, variables, options);
};
